import { DeviceInfo } from './DeviceInfo';
import { ConfigService } from '../services/config.service';
import { SimulatorModuleConfig } from './SimulatorModuleConfig';
import { SimulatorConfig } from './SimulatorConfig';


export class SimulatorHooks{
	_debug:boolean=true;
	debug(msg:string):void{
		if(this._debug){
			console.log("SimulatorHooks: "+ msg);
		}
	}

	boilerConfig:SimulatorModuleConfig;
	heatpumpConfig:SimulatorModuleConfig;
	config:ConfigService;
	constructor(private deviceInfo:DeviceInfo){
		
	}
	setConfigService(configService:ConfigService){
		this.config = configService;
	}
	simulatorConfig:SimulatorConfig;
	setSimulatorConfig(sc:SimulatorConfig){
		this.simulatorConfig = sc;
		this.boilerConfig = this.simulatorConfig.getModuleConfigByName('boiler');
		this.heatpumpConfig = this.simulatorConfig.getModuleConfigByName('heatPump');	
	}
	setDefaultVR71Config(){
		let sbc = this.simulatorConfig.solarCylinderCount();
		let vr71config = 3;
		if(sbc == 2){
			vr71config = 1;
		}
		if(sbc == 1){
			vr71config = 2;
		}
		if(this.simulatorConfig.hasAllStor()){
			vr71config = 6;
		}
		
		this.deviceInfo.getScale('configuration_vr71').setCurrentValue(vr71config);
	}
	afterSetup(){
		console.log("running after setup hooks.");
		if(!this.simulatorConfig.hasVR7x() && 
			this.deviceInfo.getRawValue('wizard_zone_option') == 'WIZARD_ZONE_OPTIONS_ENUM2' && 
			this.simulatorConfig.hasHeatpump() && 
			this.simulatorConfig.activeHeatingCircuits() == 1
			)
		{
			
			this.deviceInfo.setZoneCount(2);
			this.config.reloadMenu();


		}
	}
	setInstallerVR71Config(){
			
		let sbc = this.deviceInfo.getScale('solar_buffer_count').getCurrentValue();
		let wso = this.deviceInfo.getRawValue('wizard_solar_option');
		let vr71config = 1;
		if(['WIZARD_SOLAR_OPTIONS_ENUM3','WIZARD_SOLAR_OPTIONS_ENUM5'].includes(wso)){
			if(sbc == 2){
				vr71config = 1;
			}
			if(sbc == 1){
				vr71config = 2;
			}
		}
		if(['WIZARD_SOLAR_OPTIONS_ENUM1','WIZARD_SOLAR_OPTIONS_ENUM2'].includes(wso)){
				vr71config = 3;
		}
		if(wso == 'WIZARD_SOLAR_OPTIONS_ENUM4'){
			vr71config = 6;
		}
		this.deviceInfo.getScale('configuration_vr71').setCurrentValue(vr71config);

		let config_screen_circuits = this.simulatorConfig.heatingCircuitCount();
		let installer_ciruits = this.deviceInfo.getScale('wizard_heatingcircuit_count').getCurrentValue();		
		let ids = this.deviceInfo.getHeatingCircuitIds();
		for(let id of ids){
			let hc = this.deviceInfo.getHeatingCircuitById(id);
			if(id > installer_ciruits){
				hc.setValue('circuitType','ENUM_TYPE_OF_CIRCUIT_DEACTIVATED');
			}
		}

	}
	getAnsteuerReihenfolge():string{
		/*
			Es ist die Anzahl der gewählten „Heizgeräte“ oder die Anzahl der „Wärmepumpen“ gemeint, 
			wenn mehr als eins gewählt wird. 
			Bei einer Kombination von mehreren Wärmepumpen und einem Heizgerät wird ist nur die Anzahl 
			der Wärmepumpen gemeint. Die Anzeige hängt nur von der Einstellung auf der Auswahlseite ab.
		*/
		let count=0;
		let hpc = this.heatpumpCount();
		if(hpc > 1){
			count = hpc;
		}
		if(hpc == 0){
			count = this.boilerCount();
		}
		let arr = new Array<string>();
		for(let i=1;i<=count;i++){
			arr.push(i.toString());
		}
		return arr.join(',');
	}

    boilerCount(){
    	return this.simulatorConfig.boilerCount();
    }
    heatpumpCount(){
        return this.simulatorConfig.heatpumpCount();
    }
}

